import { Anchor, Badge, Button, Card, Flex, Grid, Tooltip } from '@mantine/core';
import { IconAward, IconBoxSeam, IconCalendar, IconChartLine, IconMail } from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router';
import prettifiedLabel from '../../constants/labelPrettifier';
import WhatsappMessagesStats from './WhatsappMessageStats';

const WhatsappMessage = ({ whatsappMessage, stats, period }) => {
  const currentDomain = useSelector((state) => state.domain.domain);
  const location = useLocation();
  const { accountId, domainId } = useParams();

  return (
    <Card key={whatsappMessage.id} mb="md" withBorder>
      <Card.Section inheritPadding py="sm">
        <Grid>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <Anchor
              href={`#${location.pathname}/${whatsappMessage.id}/details`}
              fw={600}
              mb="xs"
              style={{ display: 'block' }}
            >
              {whatsappMessage.name}
            </Anchor>
            <Flex gap="xs" wrap="wrap">
              <Badge variant="default">
                {whatsappMessage?.stored === 'whatsappManager' ? 'WhatsApp Manager' : 'BSP'}
              </Badge>
              <Badge variant="default">{prettifiedLabel(whatsappMessage?.status?.toLowerCase())}</Badge>
              <Badge variant="default">{prettifiedLabel(whatsappMessage?.category?.toLowerCase())}</Badge>
              {whatsappMessage?.quality && (
                <Badge variant="default">{prettifiedLabel(whatsappMessage?.quality?.toLowerCase())}</Badge>
              )}
              <Badge variant="default">
                {whatsappMessage.mode === 'recommender' ? (
                  <IconAward size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />
                ) : (
                  <IconMail size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />
                )}
                {prettifiedLabel(whatsappMessage.type)}
              </Badge>
              {whatsappMessage.mode === 'recommender' && whatsappMessage.productFeed && (
                <Badge variant="default">
                  <IconBoxSeam size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />
                  <Anchor
                    href={`#/accounts/${accountId}/domains/${domainId}/productFeeds/${whatsappMessage.productFeed.id}/details`}
                    target="_blank"
                    size="xs"
                  >
                    {whatsappMessage.productFeed.name}
                  </Anchor>
                </Badge>
              )}
              <Tooltip
                label={
                  <>
                    <div>Created: {new Date(whatsappMessage.createdAt).toLocaleString()}</div>
                    <div>Updated: {new Date(whatsappMessage.updatedAt).toLocaleString()}</div>
                  </>
                }
                position="top"
                withArrow
              >
                <Badge variant="default" style={{ cursor: 'pointer' }}>
                  <IconCalendar size={14} style={{ verticalAlign: 'middle' }} />
                </Badge>
              </Tooltip>
            </Flex>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 4 }}>
            <Flex justify="flex-end" align="flex-start">
              <Button component="a" href={`#${location.pathname}/${whatsappMessage.id}/analytics`} size="xs">
                Statistics <IconChartLine size={14} style={{ marginLeft: 4 }} />
              </Button>
            </Flex>
          </Grid.Col>
        </Grid>
      </Card.Section>
      <Card.Section inheritPadding py="sm">
        <Grid>
          <WhatsappMessagesStats
            stats={stats}
            whatsappMessage={whatsappMessage}
            period={period}
            currency={currentDomain.currency}
          />
        </Grid>
      </Card.Section>
    </Card>
  );
};

export default WhatsappMessage;
